import { __rest, __assign } from 'tslib';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { ChevronLeftSolidIcon } from '@compono/ui-icons';
import { useSelectableContext } from '../../Selectable/SelectableProvider.js';
import 'react';
import '../../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import { useTheme } from '../../hooks/useTheme.js';
import { SelectLegacySection } from '../SelectLegacySection.js';
import { Inline } from '../../Inline/Inline.js';
import { IconBox } from '../../IconBox/index.js';

var MultiLevelSelectLegacyBackButton = function (props) {
    var _a = props.look, look = _a === void 0 ? "link" : _a, iconLeft = props.iconLeft, children = props.children, forwardProps = __rest(props, ["look", "iconLeft", "children"]);
    var size = useSelectableContext().size;
    var handleStyleProps = useTheme().handleStyleProps;
    var _b = handleStyleProps(__assign({ look: look, size: size }, forwardProps), {
        themeKey: "selectBackButton",
    }), css = _b.css, buttonProps = __rest(_b, ["css"]);
    return (jsx(SelectLegacySection, __assign({ look: "backButton" }, { children: jsx("button", __assign({ css: css }, buttonProps, { children: jsxs(Inline, __assign({ gap: "1" }, { children: [iconLeft || (jsx(IconBox, { themeKey: "buttonIcons", size: "xs", icon: ChevronLeftSolidIcon })), children] })) })) })));
};
MultiLevelSelectLegacyBackButton.displayName =
    "MultiLevelSelectLegacyBackButton";

export { MultiLevelSelectLegacyBackButton };
//# sourceMappingURL=MultiLevelSelectLegacyBackButton.js.map
